// extracted by mini-css-extract-plugin
export var section = "sectionTable-module--section--a094f";
export var tableWrapper = "sectionTable-module--tableWrapper--4d434";
export var white = "sectionTable-module--white--32741";